import { get, post } from '@/api/request';

const URI = "/customer"

// 用户管理-用户列表
export const listWarn = (page, size, params) => post(`${URI}/?page=${page}&size=${size}`, params);
export const getBussiness = role => get(`${URI}/bussiness/${role}`);
export const getCustomer = saleMan => get(`${URI}/customer/${saleMan}`);
export const getCustomerWarn = customerId => get(`${URI}/queryCustomerWarn/${customerId}`);
export const submitCustomerWarn = params => post(`${URI}/update`, params);
export const queryTrad = params => post(`${URI}/queryTrad`, params);
export const queryOrder = params => post(`${URI}/queryOrder`, params);
// export const querySale = () => get(`${URI}/querySale`)
export const querySale = params => post(`${URI}/querySale`, params);





// WEBPACK FOOTER //
// ./src/api/system/customer.js